import React, { createContext, useContext, useState } from 'react';

const UserRoleContext = createContext();

export const useUserRole = () => useContext(UserRoleContext);

export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);

  const setUserRoleValue = (role) => {
    localStorage.setItem('userRole', role);
    setUserRole(role);
  };

  return (
    <UserRoleContext.Provider value={{ userRole, setUserRole: setUserRoleValue }}>
      {children}
    </UserRoleContext.Provider>
  );
};
